import client from "../index";
import { GET_RENTAL_HISTORY, GET_RENTAL_HISTORIES } from "./query";
import {
  CREATE_RENTAL_HISTORY,
  UPDATE_RENTAL_HISTORY,
  DELETE_RENTAL_HISTORY,
} from "./mutation";

export const apiGetRentalHistory = async (id) => {
  const result = await client.query({
    query: GET_RENTAL_HISTORY,
    variables: { id },
    fetchPolicy: "network-only",
  });
  return result.data.rentalHistory;
};

export const apiGetRentalHistories = async (input = {}) => {
  const result = await client.query({
    query: GET_RENTAL_HISTORIES,
    variables: { input },
    fetchPolicy: "network-only",
  });
  return result.data.rentalHistories;
};

export const apiCreateRentalHistory = async (input) => {
  const result = await client.mutate({
    mutation: CREATE_RENTAL_HISTORY,
    variables: { input },
  });
  return result.data.createRentalHistory.rentalHistory;
};

export const apiUpdateRentalHistory = async (input) => {
  const result = await client.mutate({
    mutation: UPDATE_RENTAL_HISTORY,
    variables: { input },
  });
  return result.data.updateRentalHistory.rentalHistory;
};

export const apiDeleteRentalHistory = async (id) => {
  const result = await client.mutate({
    mutation: DELETE_RENTAL_HISTORY,
    variables: { id },
  });
  return result.data.deleteRentalHistory;
};
